import { createVuetify } from 'vuetify';
// Import Vuetify styles with utilities disabled (configured in ../styles/vuetify.scss)
import '../styles/vuetify.scss';
import { de } from 'vuetify/locale';

const vuetify = createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#142e51',
          secondary: '#142e51',
          accent: '#142e51',
          error: '#c30000',
          info: '#00a5ff',
          success: '#00c51d',
          warning: '#ecbd00',
        },
        variables: {
          'font-family': 'Inter, sans-serif',
          'font-weight': 300,
        }
      },
    },
  },
  lang: {
    locales: { de },
    current: 'de',
  },
});

export default vuetify;
